import apiService from "../../api/api.service";
import {
  GenericProductsRequest,
  GenericProductsResponse,
} from "./genericProducts.types";
import { FilterRequest } from "../filters/filters.types";

const buildParams = (
  page: number,
  per_page: number,
  filters?: FilterRequest,
) => {
  if (!filters) return { page, per_page };
  const { section_id, seque, ...rest } = filters;
  const filtersClean = Object.fromEntries(
    Object.entries(rest).filter(([, v]) => v !== undefined),
  );
  return {
    page,
    per_page,
    ...(section_id !== undefined ? { section_id } : {}),
    ...(seque !== undefined ? { seque } : {}),
    ...(Object.keys(filtersClean).length ? { filters: filtersClean } : {}),
  };
};

export const fetchGenericProducts = ({
  type,
  slug,
  page = 1,
  per_page = 20,
  filters,
}: GenericProductsRequest): Promise<GenericProductsResponse> => {
  const params = buildParams(page, per_page, filters);

  switch (type) {
    case "section":
      return apiService.get<GenericProductsResponse>(
        `/home/section/${slug}/products`,
        { params },
      );
    case "category":
      return apiService.get<GenericProductsResponse>(
        `/categories/category/${slug}`,
        { params },
      );
    case "category_group":
      return apiService.get<GenericProductsResponse>(
        `/categories/category_group/${slug}`,
        { params },
      );
    case "category_sub_group":
      return apiService.get<GenericProductsResponse>(
        `/categories/category_sub_group/${slug}`,
        { params },
      );
    case "brand":
      return apiService.get<GenericProductsResponse>(`/brands/${slug}`, {
        params,
      });
    // Menü TEK İSTİSNA: POST. Backend bu uç noktada hem GET hem POST kabul
    // ediyor; POST tercih edilmesinin sebebi `params` içindeki `filters`
    // nesnesinin query string'e serileştirilmesi yerine gövdede olduğu gibi
    // gitmesi. Gövdenin şekli GET'teki `params` ile BİREBİR aynı — aynı
    // buildParams çıktısı, sadece taşındığı yer değişiyor.
    case "menu":
      return apiService.post<GenericProductsResponse>(
        `/menus/${slug}/items`,
        params,
      );
  }
};
